export default __webpack_public_path__ + "/images/LogoIcon.svg";